<div class="grid ">
	<div class="col-12">
		<div class="card">
			<h4>Editar Tributação</h4>
			<form #f="ngForm" name="form" novalidate>
				<div class="formgroup" *ngIf="tributacao">
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-12">
							<p-divider></p-divider>
						</div>
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="cnpj">CNPJ</label>
							<p-inputMask mask="99.999.999/9999-99" type="text" name="cnpj" id="cnpj"
							[ngModel]="tributacao.cnpj" ngModel #cnpj="ngModel"></p-inputMask>
						</div>
						<div class="field col-12 md:col-5">
							<label htmlFor="razaoSocial">Razao Social</label>
							<input type="text" pInputText name="razaoSocial" ngModel #razaoSocial="ngModel"
								[(ngModel)]="tributacao.razaoSocial" placeholder="Insira a Razão Social"/>
						</div>
						<div class="field col-12 md:col-4">
							<label htmlFor="nomeFantasia">Nome Fantasia</label>
							<input type="text" pInputText name="nomeFantasia" ngModel #nomeFantasia="ngModel"
								[(ngModel)]="tributacao.nomeFantasia"/>
						</div>

						<div class="field col-12 md:col-1">
							<label htmlFor="ddd">DDD</label>
							<input type="number" pInputText name="ddd" ngModel #ddd="ngModel"
								[(ngModel)]="tributacao.ddd"/>
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="fone">Fone</label>
							<input type="number" pInputText name="fone" ngModel #fone="ngModel"
								[(ngModel)]="tributacao.fone"/>
						</div>

						
						<div class="field col-12 md:col-2">
							<label htmlFor="cep">CEP</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								name="cep" ngModel #cep="ngModel"
								[(ngModel)]="tributacao.cep"/>
						</div>

						<div class="field col-12 md:col-6">
							<label htmlFor="logradouro">Logradouro</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								name="logradouro" ngModel #logradouro="ngModel"
								[(ngModel)]="tributacao.logradouro"/>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="numeroLogradouro">Número</label>
							<input type="number" pInputText name="numeroLogradouro" ngModel #numeroLogradouro="ngModel"
								[(ngModel)]="tributacao.numeroLogradouro"/>
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="complementoLogradouro">Complemento</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								name="complementoLogradouro" ngModel #complementoLogradouro="ngModel"
								[(ngModel)]="tributacao.complementoLogradouro"/>
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="bairro">Bairro</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								name="bairro" ngModel #bairro="ngModel"
								[(ngModel)]="tributacao.bairro" />
						</div>
						
						<div class="field col-12 md:col-1">
							<label htmlFor="uf">UF</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								name="uf" ngModel #uf="ngModel"
								[(ngModel)]="tributacao.uf"/>
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="cidade">Cidade</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								name="cidade" ngModel #cidade="ngModel" [(ngModel)]="tributacao.cidade"/>
						</div>
						<div class="field col-12 md:col-4">
							<label htmlFor="crt">CRT</label>
							<p-dropdown [options]="crts" optionLabel="label" optionValue="value"
							emptyFilterMessage="Nenhum registro" [(ngModel)]="tributacao.crt"
							name="crt" ngModel #crt="ngModel" ></p-dropdown>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="tipoRegistro">Tipo Registro</label>
							<p-dropdown [options]="tipoRegistros" [(ngModel)]="tributacao.tipoRegistro"
							emptyFilterMessage="Nenhum registro" name="tipoRegistro" ngModel #tipoRegistro="ngModel" ></p-dropdown>
						</div>
						<div class="field col-12 md:col-2">
							<label for="moduloHabilitado">Habilitar Módulo</label>
							<br/>
							<p-inputSwitch  name="moduloHabilitado" [(ngModel)]="tributacao.moduloHabilitado"></p-inputSwitch>
							
						</div>
						<div class="field col-12 md:col-1">
							<label for="excluido">Excluído?</label>
							<br/>
							<p-inputSwitch  name="excluido" [(ngModel)]="tributacao.excluido"></p-inputSwitch>
							
						</div>
						<div class="field col-12 md:col-12">
							<p-divider></p-divider>
						</div>

						<div class="field col-12 md:col-4" *ngIf="tributacao.tipoRegistro === 'DANFE'">
							<label htmlFor="inscricaoEstadual">Inscrição Estadual</label>
							<input type="number" pInputText name="inscricaoEstadual" ngModel #inscricaoEstadual="ngModel"
								[(ngModel)]="tributacao.inscricaoEstadual"/>
						</div>
						<div class="field col-12 md:col-8" *ngIf="tributacao.tipoRegistro === 'DANFE'">
							<label htmlFor="csc">CSC</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								name="csc" ngModel #csc="ngModel"
								[(ngModel)]="tributacao.csc"/>
						</div>
						<div class="field col-12 md:col-2" *ngIf="tributacao.tipoRegistro === 'DANFE'">
							<label htmlFor="serieNfce">Série NFCE</label>
							<input type="number" pInputText name="serieNfce" ngModel #serieNfce="ngModel"
								[(ngModel)]="tributacao.serieNfce"/>
						</div>
						<div class="field col-12 md:col-2" *ngIf="tributacao.tipoRegistro === 'DANFE'">
							<label htmlFor="ultimoNumero">Nº do Último DANFE</label>
							<input type="number" pInputText name="ultimoNumero" ngModel #ultimoNumero="ngModel"
								[(ngModel)]="tributacao.ultimoNumero"/>
						</div>
						<div class="field col-12 md:col-8" *ngIf="tributacao.tipoRegistro === 'DANFE'">
							<label htmlFor="msgDanfe">Mensagem Danfe</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								name="msgDanfe" ngModel #msgDanfe="ngModel"
								[(ngModel)]="tributacao.msgDanfe"/>
						</div>
						<div class="field col-12 md:col-2" *ngIf="tributacao.tipoRegistro === 'DANFE'">
							<label>% IBS UF</label>
							<input type="number" pInputText
								name="pIbsUf" #pIbsUf="ngModel"
								[(ngModel)]="tributacao.pIbsUf"/>
						</div>
						<div class="field col-12 md:col-2" *ngIf="tributacao.tipoRegistro === 'DANFE'">
							<label>% IBS Mun</label>
							<input type="number" pInputText
								name="pIbsMun" #pIbsMun="ngModel"
								[(ngModel)]="tributacao.pIbsMun"/>
						</div>
						<div class="field col-12 md:col-2" *ngIf="tributacao.tipoRegistro === 'DANFE'">
							<label>% CBS</label>
							<input type="number" pInputText
								name="pCbs" #pCbs="ngModel"
								[(ngModel)]="tributacao.pCbs"/>
						</div>

						<div class="field col-12 md:col-3" *ngIf="tributacao.tipoRegistro === 'RPS'">
							<label htmlFor="inscricaoMunicipal">Inscrição Municipal</label>
							<input type="number" pInputText name="inscricaoMunicipal" ngModel #inscricaoMunicipal="ngModel"
								[(ngModel)]="tributacao.inscricaoMunicipal"/>
						</div>
						<div class="field col-12 md:col-3" *ngIf="tributacao.tipoRegistro === 'RPS'">
							<label htmlFor="codigoAtividade">Codigo da Atividade(CNAE)</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								name="codigoAtividade" ngModel #codigoAtividade="ngModel"
								[(ngModel)]="tributacao.codigoAtividade"/>
						</div>
						<div class="field col-12 md:col-3" *ngIf="tributacao.tipoRegistro === 'RPS'">
							<label htmlFor="tipoRecolhimento">Tipo Recolhimento</label>
							<p-dropdown [options]="tiposTributacaoR" optionLabel="descricao"
							optionValue="id" [(ngModel)]="tributacao.tipoRecolhimento"
							emptyFilterMessage="Nenhum registro" name="tipoRecolhimento" ngModel #tipoRecolhimento="ngModel" ></p-dropdown>
						</div>
						
						<div class="field col-12 md:col-3" *ngIf="tributacao.tipoRegistro === 'RPS'">
							<label htmlFor="tributacao">Tributação</label>
							<p-dropdown [options]="tiposTributacaoT" optionLabel="descricao"
							optionValue="id" [(ngModel)]="tributacao.tributacao" emptyFilterMessage="Nenhum registro"
							name="tributacao" ngModel #tributacaoT="ngModel" ></p-dropdown>
						</div>
						<div class="field col-12 md:col-2" *ngIf="tributacao.tipoRegistro === 'RPS'">
							<label htmlFor="aliquotaIss">Alíquota ISS</label>
							<p-inputNumber suffix="%" name="aliquotaIss" ngModel #aliquotaIss="ngModel"
                                    [max]="100" [minFractionDigits]="2" [maxFractionDigits]="2" [allowEmpty]="false"
                                    [(ngModel)]="tributacao.aliquotaIss">
                            </p-inputNumber>
						</div>
						<div class="field col-12 md:col-2" *ngIf="tributacao.tipoRegistro === 'RPS'">
							<label htmlFor="ultimoNumero">Nº do Último RPS</label>
							<input type="number" pInputText name="ultimoNumero" ngModel #ultimoNumero="ngModel"
								[(ngModel)]="tributacao.ultimoNumero"/>
						</div>
						<div class="field col-12 md:col-5" *ngIf="tributacao.tipoRegistro === 'RPS'">
							<label htmlFor="urlServidorIss">URL Servidor ISS</label>
							<input type="text" pInputText
								name="urlServidorIss" ngModel #urlServidorIss="ngModel"
								[(ngModel)]="tributacao.urlServidorIss"/>
						</div>
						<div class="field col-12 md:col-3" *ngIf="tributacao.tipoRegistro === 'RPS'">
							<label htmlFor="cpfTomadorValido">CPF Tomador Valido</label>
							<p-inputMask mask="999.999.999-99" [unmask]="true"   type="text" placeholder="000.000.000-00"
								name="cpfTomadorValido" ngModel #cpfTomadorValido="ngModel"
								[(ngModel)]="tributacao.cpfTomadorValido"> </p-inputMask>
						</div>
						<div class="field col-12 md:col-2" *ngIf="tributacao.tipoRegistro === 'RPS'">
							<label htmlFor="certificadoDigital">Certificado Digital?</label>
							<p-dropdown [options]="opcoesCertificadoDigital" optionValue="label" optionValue="value"
							 [(ngModel)]="tributacao.certificadoDigital"name="certificadoDigital" 
							 ngModel #certificadoDigital="ngModel" ></p-dropdown>
						</div>
					</div>
					<div class="p-fluid p-formgrid grid">
						<div class="field col-12 md:col-2" *ngIf="!progressoRequisicao">
							<button type="submit" pButton icon="pi pi-check" label="Atualizar" (click)="atualizar()"
								class="p-button-success mt-5"></button>
						</div>
						<div class="field col-12 md:col-2" *ngIf="progressoRequisicao">
							<button type="submit" pButton icon="pi pi-spin pi-spinner" label="Atualizando..."
								class="p-button-success mt-5" [disabled]="true"></button>
						</div>
						<div class="field col-12 md:col-8">
						</div>
						<div class="field col-12 md:col-2">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-primary mt-5" (click)="voltar()"></button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>